import store from '@/store/index.js'
import riaApiClient from "@/api";
import { getPlatformType } from '@/helpers/deviceHelpers'

const version = process.env.VUE_APP_API_VERSION;

const defaultDetail = {
  "person_id": null,
  "firstname": "",
  "lastname": "",
  "photo": "",
  "birthdate": "",
  "keycard_id": null,
  "keycard": "",
  "date": "",
  "quantity": 1,
  "product_id": "",
  "participant_id": "",
  "extras": []
};

const initialOrder = {
  "environment_id": null,
  "payment_gateway_id": null,
  "resort_id": null,
  "firstname": "",
  "lastname": "",
  "email": "",
  "phone": "",
  "customer_id": null,
  "promotion_id": null,
  "platform": getPlatformType(),
  "user_agent": navigator.userAgent,
  //"currency": "",
  "details": [ ]
}

export default {
  namespaced: true,
  state: {
    _order: JSON.parse(JSON.stringify(initialOrder)),
    _checkout: {},
    _validate: {},
    _ordersUser: {},
    _orderDetails: {}
  },
  getters: {
    validate: state => state._validate,
    checkout: state => state._checkout,
    order: state => state._order,
    details: state => state._order.details,
    ordersUser: state => state._ordersUser.sort((oldVal, newVal) => newVal.id - oldVal.id),
    orderDetails: state => state._orderDetails,
    detailsSelected: state => state._order.details.map((detail) => detail.person_id).filter(Boolean),
    totalPrice: state => {
      return state._order.details.map((detail) => {
        const productPrice = store.getters['prices/productPrice'](detail.date, detail.participant_id)
        const extrasPrice = detail.extras.reduce((carry, extra) => {
          return carry + store.getters['prices/extraPrice'](extra, detail.participant_id)
        }, 0)
         const keycardPrice = detail.keycard.new?store.getters['prices/keycardPrice'](detail.date, detail.participant_id):0;

        return keycardPrice + productPrice + extrasPrice
      }).reduce((carry, price) => carry + price , 0)
    },
    totalPricePromo(state, getters){
      return getters.totalPrice - store.getters['prices/promoPrice']
    },
    totalTax(state, getters , rootState, rootGetters) {
      return state._order.details.reduce((carry, detail) => {
        const catalog = rootGetters['resort/selectedCatalog']
        const products = catalog.products.filter((p) => p.id == detail.product_id)
        if (products.length <= 0) {
          console.error('ERROR product not found')
        }

        const taxPercent = products[0].tax.percent
        const productPrice = rootGetters['prices/productPrice'](detail.date, detail.participant_id)

        let extraTaxes = detail.extras.reduce((carry, extraId) => {
          const extraPrice = rootGetters['prices/extraPrice'](extraId, detail.participant_id)
          const extras = catalog.products.filter((e) => e.id == extraId)
          if (extras.length <= 0) {
            console.error('ERROR extra not found')
          }
          return carry + extraPrice - (extraPrice / (1 + extras[0].tax.percent / 100))
        }, 0)

        let keycardTax = 0
        if (detail.keycard.new != undefined) {
          const keycardTaxPercent = products[0].keycard.tax.percent
          let keycardPrice = rootGetters['prices/keycard']['best_prices'][detail.participant_id].best_amount
          if (detail.date != null) {
            keycardPrice = rootGetters['prices/keycard'][detail.date][detail.participant_id].best_amount
          }
          keycardTax = keycardPrice - (keycardPrice / (1 + keycardTaxPercent / 100))
        } 

        return carry + keycardTax + extraTaxes + (productPrice - (productPrice / (1 + taxPercent / 100)))

      }, 0)
    },
    languageHeader(){
      return {'Content-Language': store.getters['device/language']}
    }
  },
  actions: {
      setOrderField(context, payload){
        context.commit("SET_ORDER_FIELD", payload);
      },
      addDetail(context, {date, participant}) {
        context.commit("ADD_DETAIL", {
          ...defaultDetail,
          date,
          product_id: store.getters['resort/selectedProduct'].id,
          participant_id: participant.id,
          participant_name: participant.name,
          participant_description: participant.description,
        });
      },
      removeDetail(context, payload) {
        context.commit("REMOVE_DETAIL", payload);
      },
      changeDetailsField(context, {field, value}) {
        context.state._order.details.forEach((detail, index) => {
          context.commit("SET_DETAIL_FIELD", { index, field, value });
        })
      },
      async sendCheckout(context, payload){
        const response = await riaApiClient.post(`/api/${version}/checkout_order`, payload, {headers: context.getters.languageHeader });
        context.commit("SET_CHECKOUT", response.data);
      },
      async validateOrder(context, payload){
        try {
          const response = await riaApiClient.post(`/api/${version}/validate_order`, payload, {headers: context.getters.languageHeader });
          context.commit("SET_VALIDATE", response);
        }
        catch(error){
          context.commit("SET_VALIDATE", null)
        }
      },
      resetDetails(context) {
        context.commit("SET_ORDER_FIELD", { field: 'details', value: [] });
      },
      restoreDetails(context) {
        const details = context.state._order.details.map(detail => {
          return {
            ...defaultDetail,
            product_id: store.getters['resort/selectedProduct'].id,
            date: detail.date,
            participant_id: detail.participant_id,
            participant_name: detail.participant_name,
            participant_description: detail.participant_description,
          }
        })
        context.commit("SET_ORDER_FIELD", { field: 'details', value: details });
      },
      sortDetails(context) {
        context.commit("SORT_DETAILS")
      },
      async ordersUser(context, payload){
        const response = await riaApiClient.get(`/api/${version}/customers/${payload.id}/orders`, {params: {page_size: 999}});
        context.commit("SET_ORDERS", response.data.data);
      },
      setOrderDetails(context, payload){
        context.commit("SET_ORDER_DETAILS", payload)
      },
      initOrder(context) {
        context.commit("SET_INIT_ORDER")
      }
  },
  mutations: {
    SET_ORDER(state, payload){
      state._order = payload;
    },
    SET_VALIDATE(state, payload){
        state._validate = payload;
    },
    SET_CHECKOUT(state, payload){
        state._checkout = payload;
    },
    ADD_DETAIL(state, payload) {
      state._order.details = [...state._order.details, payload]
    },
    REMOVE_DETAIL(state, payload) {
      const index = state._order.details.findIndex(detail => detail.participant_id == payload.participantId)
      state._order.details.splice(index,1)
    },
    SET_DETAIL(state, payload) {
        state._order.details = state._order.details.map((participant, key) => {
            if (payload.index === key) {
                return payload.participant
            }
            return participant
        })
    },
    SET_DETAIL_FIELD(state, {index, field, value }) {
        state._order.details = state._order.details.map((participant, key) => {
            if (index === key) {
                const fieldToChange = {}
                fieldToChange[field] = value
                return { ...participant, ...fieldToChange}
            }
            return participant
        })
    },
    SET_ORDER_FIELD(state, {field, value}) {
        state._order[field] = value;
    },
    SORT_DETAILS(state) {
      const participantsId =  store.getters['resort/selectedCatalog'].participants.map(p => p.id)
      state._order.details = [...state._order.details].sort((a, b) => {
        const aPosition = participantsId.indexOf(a.participant_id);
        const bPosition = participantsId.indexOf(b.participant_id);
        return aPosition - bPosition
      })
    },
    SET_ORDERS(state, payload) {
      state._ordersUser = payload;
    },
    SET_ORDER_DETAILS(state, payload) {
      state._orderDetails = payload;
    },
    SET_INIT_ORDER(state) {
      state._order = JSON.parse(JSON.stringify(initialOrder))
      state._checkout = {}
      state._validate = {}
      state._ordersUser = {}
      state._orderDetails = {}
    }
  }
};
